import { Badge, type BadgeTone } from '@skupreme/shared/ui';

// Connection statuses other than active are the ones staff look for, so they
// get the loud tones. Anything not listed renders neutral.
const TONES: Record<string, BadgeTone> = {
  active: 'success',
  paused_credential: 'danger',
  paused_provider: 'warning',
  disabled: 'caution',
  suspended: 'danger',
  blocked: 'danger',
  closed: 'neutral',
  pending: 'warning',
  invited: 'warning',
  expired: 'caution',
};

export function StatusBadge({ status }: { status: string }) {
  return <Badge tone={TONES[status] ?? 'neutral'}>{status}</Badge>;
}
